  <div class="d-flex flex-wrap justify-content-between">
    <div class="m-2">
      <a routerLink="/">
        <button type="button"
                class="btn btn-outline-primary"
                routerLinkActive="active-button"
                [routerLinkActiveOptions]="{exact: true}">
          <span i18n>Domov</span>
        </button>
      </a>
    </div>
    <app-zalozka class="m-2" *ngFor="let z of zalozky" [zalozka]="z"></app-zalozka>
  </div>
